import { Component, HostListener } from '@angular/core';
import { AuthService } from '@app/shared/auth/auth.service';
import { cognitoRedirectUrl } from '@app/shared/auth/auth.config';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-root',
  template: '<app-loader></app-loader><router-outlet></router-outlet>',
  standalone: false,
})
export class AppComponent {
  constructor(private authService: AuthService) {}

  @HostListener('document:visibilitychange')
  onVisibilityChange() {
    if (document.visibilityState === 'visible') {
      this.checkToken();
    }
  }

  private checkToken() {
    if (!this.authService.isSessionExpired()) {
      return;
    }
    this.authService
      .refreshToken()
      .pipe(
        catchError(() => {
          this.authService.clear();
          window.location.href = cognitoRedirectUrl;
          return of(null);
        }),
      )
      .subscribe((authResult) => {
        if (authResult) {
          this.authService.handleRefreshResponse(authResult);
        }
      });
  }
}
